import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "@/assets/js/models/helpers/JsonMapper";
import UserTries from "@/assets/js/models/user/UserTries";
var _attributes = /*#__PURE__*/new WeakMap();
export default class UserCustomData extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [UserCustomData.import_product_tries_attribute_name]: UserTries,
      [UserCustomData.sale_page_ai_tries_attribute_name]: UserTries
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getImportProductTriesAttributeName() {
    return this.import_product_tries_attribute_name;
  }
  static getSalePageTriesAttributeName() {
    return this.sale_page_ai_tries_attribute_name;
  }
  getProductImportTries() {
    return this.getAttribute(UserCustomData.getImportProductTriesAttributeName());
  }
  getSalePageAiTries() {
    return this.getAttribute(UserCustomData.getSalePageTriesAttributeName());
  }
  getProductTries() {
    const importTries = this.getProductImportTries();
    return importTries instanceof UserTries ? importTries.getTries() : 0;
  }
  getSalePageTries() {
    const importTries = this.getSalePageAiTries();
    return importTries instanceof UserTries ? importTries.getTries() : 0;
  }
}
_defineProperty(UserCustomData, "import_product_tries_attribute_name", 'import_product_tries');
_defineProperty(UserCustomData, "sale_page_ai_tries_attribute_name", 'sale_page_ai_tries');